import { ItinerarySummaryCms } from "@contracts/itinerary";
import { shrpaApi } from "./axios";

export async function fetchCollabAdventures(customerId: string, collabInputId: string, creatorId: string) {
  const { data } = await shrpaApi.get<ItinerarySummaryCms[]>(`collabs/${customerId}/inputs/${collabInputId}/creator/${creatorId}/adventures`);
  return data;
}
